

class SwiperSliderCollection extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.windowWidth = window.innerWidth;
    }

    debounce(func, wait) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    connectedCallback() {

        this.windowWidth < 1024 ? this.swiperBuild() : null;

        window.addEventListener('resize', this.debounce(() => {
            this.windowResize();
        }, 100));
    }

    windowResize() {
        if (this.windowWidth !== window.innerWidth) {
            
            this.windowWidth = window.innerWidth;

            if (this.windowWidth < 1024) {
                if (this.swiper === null) {
                    this.debounce(this.swiperBuild(), 100);
                }
            } else {
                if (this.swiper !== null) {
                    this.debounce(this.swiperDestroy(), 100);
                }
            }
        }
    }

    swiperBuild() {
        const container = this;
        const nextEl = this.querySelector('.swiper-button-next');
        const prevEl = this.querySelector('.swiper-button-prev');
  
        if (!container || !nextEl || !prevEl) {
          console.warn('Swiper: missing container or nav elements', { container, nextEl, prevEl });
          return;
        }

        this.swiper = new Swiper(container, {
            loop: false,
            slidesPerView: 1.5,
            navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
            },
            spaceBetween: 10,
        });
    }

    swiperDestroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }

    disconnectedCallback() {
        this.swiperDestroy();
      }
}

customElements.define('swiper-slider-collection', SwiperSliderCollection);